import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';

import { ApiColbensonSearch } from './api-colbenson.models';


export interface ApiColbensonServiceInterface {
  search(storeId: string, languageCode: string, catalogId: string, warehouse: string, query: string): Observable<ApiColbensonSearch>;
}

@Injectable()
export class ApiColbensonService implements ApiColbensonServiceInterface {

  constructor(
    private readonly ecommerceConfigService: EcommerceConfigService,
    private readonly http: HttpClient
  ) { }

  public search(storeId: string, languageCode: string, catalogId: string, warehouse: string, query: string): Observable<ApiColbensonSearch> {
    const url = this.requestUrl(storeId, languageCode, catalogId, warehouse, query);
    return this.http.get<ApiColbensonSearch>(url).pipe(
      catchError((error) => (error.httpStatus === 404 ? of({}) : of(error)))
    );
  }

  /* @example
     https://api-staging.empathybroker.com/search/v1/query/oysho/searchv3?lang=es&catalogue=60361120&store=64009600&warehouse=62109610&q=pantalon
  */
  private requestUrl(storeId: string, languageCode: string, catalogId: string, warehouse: string, query: string): string {
    const config = this.ecommerceConfigService.getConfig();
    let url = '';
    if (config.providers.colbensonSearchUrl) {
      url = `${config.providers.colbensonSearchUrl}`
        + `?lang=${languageCode}&catalogue=${catalogId}&store=${storeId}&warehouse=${warehouse}&q=${query}&rows=10`;
    }
    return url;
  }

}
